<template>
  <div class="ws-sort-item">
    <slot></slot>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>